export enum CertificateTypesOfficial {
  SUPERVISOR_GOLD_BADGE = 'Supervisor Gold Badge',
  SUPERVISOR_SILVER_BADGE = 'Supervisor Silver Badge',
  SUPERVISOR_WHITE_BADGE = 'Supervisor White Badge',
  SUPERVISOR_NATIONAL = 'Supervisor National',
  CHAIR_GOLD_BADGE = 'Chair Gold Badge',
  CHAIR_SILVER_BADGE = 'Chair Silver Badge',
  CHAIR_BRONZE_BADGE = 'Chair Bronze Badge',
  CHAIR_WHITE_BADGE = 'Chair White Badge',
  CHAIR_NATIONAL = 'Chair National',
  CHIEF_GOLD_BADGE = 'Chief Gold Badge',
  CHIEF_SILVER_BADGE = 'Chief Silver Badge',
  CHIEF_WHITE_BADGE = 'Chief White Badge',
  CHIEF_NATIONAL = 'Chief National',
  LINE_UMPIRE = 'Line Umpire',
  ROVING_UMPIRE = 'Roving Umpire',
  REVIEW_OFFICIAL = 'Review Official',
}
